import Vue from 'vue';
import router from './router';
import Vuelidate from 'vuelidate';
import VueApexCharts from 'vue-apexcharts';

Vue.use(VueApexCharts);
Vue.use(Vuelidate);

import 'style/_global.scss';

new Vue({
    router,
    render: h => h('router-view'),
}).$mount('#app');
